import * as yup from 'yup'
import {getTypeDocument} from '../util/functions'

export const person = (documentTypes: any[] = []) => {
  return yup.object().shape({
    tipoDocumento: yup.string().required('El tipo de documento es obligatorio'),
    numeroDocumento: yup
      .string()
      .test({
        name: 'dynamicValidation',
        message: 'Cantidad de carácteres no validos',
        test: async function (texto) {
          const tipo = this.parent.tipoDocumento
          if (!tipo || tipo === '00') {
            return true
          }
          const tipoDocumento = documentTypes.find((item) => item.value === tipo)
          if (!tipoDocumento) {
            return true
          }
          const length = tipoDocumento.length
          const length2 = tipoDocumento.length2
          if (tipo === '00') {
            if (texto && Number(texto.length) < 7) {
              return this.createError({
                message: `Por favor, no escribas menos de 7 caracteres.`, // Modifica el mensaje de error
                path: this.path,
              })
            }
          } else if (tipo === '01') {
            if (texto && texto.length !== Number(length)) {
              return this.createError({
                message: `Por favor, no ingrese menos de ${length} caracteres.`,
                path: this.path,
              })
            }
          } else {
            if (texto && (texto.length < Number(length) || texto.length > Number(length2))) {
              return this.createError({
                message: `Por favor, ingrese entre ${length} y ${length2} caracteres.`,
                path: this.path,
              })
            }
          }

          return true
        },
      })
      .required('Campo requerido'),
    nombres: yup.string().required('El nombre es obligatorio'),
    apellidoPaterno: yup.string().required('El apellido paterno es obligatorio'),
    apellidoMaterno: yup.string().required('El apellido materno es obligatorio'),
    email: yup.string().email('Formato de email invalido'),
    sexoId: yup.string().required('El sexo es obligatorio'),
    estado: yup.string().required('El estado es obligatorio'),
  })
}


export const documentByPerson = yup.object().shape({
  documento: yup.object().shape({
    tipoDocumento: yup.string().required('El tipo de documento es obligatorio'),
    numeroDocumento: yup
      .string()
      .test({
        name: 'dynamicValidationDoc',
        message: 'Cantidad de carácteres no validos',
        test: async function (texto) {
          const tipo = this.parent.tipoDocumento
          if (!tipo || tipo === '00') {
            return true
          }
          const maxLengthOptions = await getTypeDocument()
          const tipoDocumento = maxLengthOptions.find((item) => item.value === tipo)
          if (!tipoDocumento) {
            return true
          }
          const length = tipoDocumento.length
          const length2 = tipoDocumento.length2

          if (tipo === '00') {
            if (texto && Number(texto.length) < 7) {
              return this.createError({
                message: `Por favor, no escribas menos de 7 caracteres.`, // Modifica el mensaje de error
                path: this.path,
              })
            }
          } else if (tipo === '01') {
            if (texto && texto.length !== Number(length)) {
              return this.createError({
                message: `Por favor, no ingrese menos de ${length} caracteres.`,
                path: this.path,
              })
            }
          } else {
            if (texto && (texto.length < Number(length) || texto.length > Number(length2))) {
              return this.createError({
                message: `Por favor, ingrese entre ${length} y ${length2} caracteres.`,
                path: this.path,
              })
            }
          }

          return true
        },
      })
      .required('Campo requerido'),
    estado: yup.string().required('El estado es obligatorio'),
  }),
})

export const personClothing = yup.object().shape({
  TipoPrendaId: yup.string().required('El tipo de ropa es obligatorio'),
  Cantidad: yup.number().typeError("Cantidad es obligatoria")
  .required("Cantidad es obligatoria"),
  CodigoPrenda: yup.string().required('El código de prenda es obligatorio'),
  Observacion: yup.string()
})